<bms-common-popup
  [icon]="'notifications_active'"
  [title]="'Send Notification to Finance'"
  [subTitle]="'Notify finance team members to review and process this policy draft.'"
  [cancelTitle]="'Cancel'"
  [submitTitle]="'Send Notification'"
  (onCancelClick)="onCancel()"
  (onSubmitClick)="onSubmit()"
  [isSubmitEnabled]="hasSelectedUsers && form.valid"
>
  <div class="send-to-finance-container">
    <!-- Search / Header bar -->
    <div class="section-header d-flex justify-content-between align-items-center mb-2">
      <div class="d-flex align-items-center">
        <mat-icon class="section-icon mr-2 text-primary">groups</mat-icon>
        <div>
          <span class="font-weight-bold section-title">Select Finance Recipients</span>
          <div class="text-muted small">Select the users who should receive this notification</div>
        </div>
      </div>
      <div *ngIf="users.length > 1" class="select-all-box">
        <mat-checkbox
          [checked]="isAllSelected"
          [indeterminate]="isSomeSelected"
          (change)="toggleSelectAll($event.checked)"
          color="primary"
        >
          Select All ({{ users.length }})
        </mat-checkbox>
      </div>
    </div>

    <!-- Search input if users > 3 -->
    <div *ngIf="users.length > 3" class="search-input-box mb-2">
      <mat-form-field appearance="outline" class="w-100 search-field">
        <mat-icon matPrefix class="mr-2 text-muted">search</mat-icon>
        <input
          matInput
          [(ngModel)]="searchTerm"
          placeholder="Search finance user by name or email..."
        />
        <button
          mat-icon-button
          matSuffix
          *ngIf="searchTerm"
          (click)="searchTerm = ''"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Recipients List -->
    <div class="recipients-list-wrapper custom-scrollbar mb-3">
      <div *ngIf="filteredUsers.length === 0" class="empty-users text-center p-3 text-muted">
        <mat-icon class="empty-icon mb-1">person_search</mat-icon>
        <p class="mb-0">No finance users found.</p>
      </div>

      <div
        *ngFor="let user of filteredUsers"
        class="user-item-row d-flex align-items-center justify-content-between p-2 mb-2 rounded"
        [class.selected]="user.isSelect"
        (click)="toggleUser(user)"
      >
        <div class="d-flex align-items-center">
          <mat-checkbox
            [(ngModel)]="user.isSelect"
            (click)="$event.stopPropagation()"
            color="primary"
            class="mr-2"
          ></mat-checkbox>
          <div class="user-avatar-circle mr-3">
            <mat-icon>account_circle</mat-icon>
          </div>
          <div class="user-info">
            <div class="user-name font-weight-500">{{ user.name }}</div>
            <div class="user-email text-muted small">{{ user.email }}</div>
          </div>
        </div>
        <div class="user-role-badge">
          <span class="badge badge-light-primary px-2 py-1">{{ user.role || 'Finance' }}</span>
        </div>
      </div>
    </div>

    <hr class="divider my-3" />

    <!-- Remarks / Message section -->
    <form [formGroup]="form">
      <div class="section-header d-flex align-items-center mb-2">
        <mat-icon class="section-icon mr-2 text-primary">chat_bubble_outline</mat-icon>
        <div>
          <span class="font-weight-bold section-title">Notification Message / Remarks</span>
          <div class="text-muted small">This message will be included in the notification to finance</div>
        </div>
      </div>

      <mat-form-field appearance="outline" class="w-100 remarks-field">
        <textarea
          matInput
          rows="3"
          formControlName="remarks"
          placeholder="Enter remarks or instructions for the finance team..."
        ></textarea>
        <mat-error *ngIf="form.get('remarks')?.hasError('required')">
          Remarks are required
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</bms-common-popup>
